import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-middle" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "block mt-2 text-xs text-primary",
      id: "show-instructions",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.item.title,
      onOk: _ctx.handleOk,
      "cancel-button-props": { hidden: true},
      "ok-button-props": {shape: 'round', size: 'large'}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.item.description
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}